// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentOrdersStyles } from "@guestsupply/Overrides/Widgets/Common/RecentOrders";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import Print from "@guestsupply/XDL/Icons/Print";
import { color, createLinkIconStyles, styledScrollbar, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

recentOrdersStyles.titleSectionWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            flex-wrap: wrap;
        }
    `,
};

recentOrdersStyles.title = {
    ...dataTableStyles.title,
    variant: "h2",
    weight: 400,
    css: css`
        order: 0;
        flex-grow: 1;
        margin-bottom: 0;
        ${xScreen("lte", "sm")} {
            width: 50%;
            @media print {
                width: auto;
            }
        }
    `,
};

recentOrdersStyles.pagination = {
    size: 14,
    css: css`
        order: 1;
        padding-right: 16px;
        border-right: 1px solid ${color("common.border")};
        ${xScreen("lte", "sm")} {
            order: 2;
            width: 50%;
            border-right: none;
            margin-top: 10px;
            @media print {
                width: auto;
                padding-right: 0;
                margin-top: 0;
            }
        }
    `,
};

recentOrdersStyles.bold = {
    weight: "bold",
};

recentOrdersStyles.printButton = {
    ...createLinkIconStyles(Print, {
        typographyProps: {
            css: css`
                margin-left: 0;
            `,
        },
        icon: {
            position: "left",
            iconProps: {
                css: css`
                    margin: 0 10px 0 16px;
                `,
            },
        },
        css: css`
            order: 2;
            height: 24px;
            padding-right: 16px;
            border-right: 1px solid ${color("common.border")};
            ${xScreen("lte", "sm")} {
                order: 1;
                padding-right: 0;
                border-right: none;
            }
        `,
    }),
};

recentOrdersStyles.link = {
    ...createLinkIconStyles(CaretRight, {
        typographyProps: {
            css: css`
                margin-left: 16px;
                text-transform: capitalize;
            `,
        },
        icon: {
            iconProps: {
                size: 12,
                css: css`
                    margin-left: 10px;
                `,
            },
        },
        css: css`
            order: 3;
            ${xScreen("lte", "sm")} {
                width: 50%;
                margin-top: 10px;
            }
            @media print {
                display: none;
            }
        `,
    }),
};

recentOrdersStyles.dataTableHead = {
    css: css`
        line-height: 15px;
    `,
};

recentOrdersStyles.tableWrapper = {
    css: css`
        padding: 0;
    `,
};

recentOrdersStyles.noOrdersFoundGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentOrdersStyles.noOrdersFoundText = {
    ...dataTableStyles.noResultsText,
};

recentOrdersStyles.orderSummaryCard = {
    shipToCell: {
        css: css`
            @media print {
                width: 100%;
            }
        `,
    },
};
